import React from 'react';

import { offsetDateForBrowser } from '../../../shared/timeZoneLogic';

export const parseDateTime = (dateTime) => {
  if (dateTime){
    if (typeof(dateTime) === "string") {
      var dateObj = new Date(dateTime);
      return dateObj;
    } else {
      return dateTime;
    }
  }
}

export const parseFloatFromString = (value) => {
  if(typeof(value) === "number"){
    return value;
  }

  return parseFloat(value.split(",").join(""));
}

export const visiblePricePoints = (pricePoints) => {
  if (!pricePoints) {
    return [];
  }

  return pricePoints
    .filter((pricePoint) => !pricePoint._destroy)
    .sort((a, b) => new Date(a.starts_at) - new Date(b.starts_at));
};

export const minPerOrderMoreThanMax = (addOn) => {
  var minimumPerOrder;
  if(addOn.minimum_per_order){
    minimumPerOrder = parseFloatFromString(addOn.minimum_per_order);
  }

  var maximumPerOrder;
  if(addOn.maximum_per_order){
    maximumPerOrder = parseFloatFromString(addOn.maximum_per_order);
  }

  return (
    minimumPerOrder
      && maximumPerOrder
      && minimumPerOrder > maximumPerOrder
  );
};

export const canSubmitForm = (addOn) => {
  var minimumPerOrder;
  if(addOn.minimum_per_order){
    minimumPerOrder = parseFloatFromString(addOn.minimum_per_order);
  }

  var maximumPerOrder;
  if(addOn.maximum_per_order){
    maximumPerOrder = parseFloatFromString(addOn.maximum_per_order);
  }

  var startTime = addOn.start_time;
  var endTime   = addOn.end_time;

  var pricePointsValid = (visiblePricePoints(addOn.price_points) || []).every((pricePoint) => {
    return (
      pricePoint.starts_at
        && pricePoint.price_two_decimals
    );
  });

  const timedEntryValid =
    !addOn.timed_entry ||
    (
      addOn.timed_entry_availability === "Date & Time" &&
      addOn.timed_entry_start &&
      addOn.timed_entry_end
    ) ||
    (
      addOn.timed_entry_availability === "Based on show details" &&
      addOn.timed_entry_start_show_activity_id &&
      addOn.timed_entry_end_show_activity_id
    );

  return (
    addOn
      && addOn.base_name
      && addOn.available
      && addOn.base_price_two_decimals
      && minimumPerOrder
      && maximumPerOrder
      && minimumPerOrder <= maximumPerOrder
      && pricePointsValid
      && timedEntryValid
      && addOn.check_in_limit >= 0
      && ((
        addOn.availability === "Date & Time"
        && startTime
        && endTime
        && startTime <= endTime
      ) || (
        addOn.availability === "Based on show details"
        && addOn.start_show_activity_id
        && addOn.end_show_activity_id
      ))
  );
};

export const addOnIsSeated = (addOn) => {
  return (
    addOn
      && addOn.seating_chart_category_key
      && addOn.seating_chart_category_key.length > 0
  )
}

export const isSharingInventory = (addOns, addOn) => {
  return (
    addOn.share_inventory_with_id
      || addOns.find((ao) => ao.share_inventory_with_id === addOn.id)
  )
}

export const showActivityOption = (showActivity) => {
  if (!showActivity) {
    return null;
  }

  const formattedTime = offsetDateForBrowser(showActivity.start_time).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });

  const label = showActivity.set ? (
    `${showActivity.name} - ${formattedTime}`
  ): (
    <>
      {showActivity.name}
      <span style={{ color: "var(--sl-text-error)" }}> Date not set yet</span>
    </>
  );

  return {
    value: showActivity.id,
    label,
  }
}

export const requiredAddOnOptions = (addOns, addOnForForm) => (
  addOns
    .filter((addOn) => addOn.id !== addOnForForm.id)
    .map((addOn) => ({ value: addOn.id, label: addOn.base_name || addOn.name }))
    .sort((a, b) => a.label.localeCompare(b.label))
);
